module.exports = __webpack_public_path__ + "static/media/pdfLogo.f211db73.svg";